import { autoinject } from 'aurelia-framework';
import { UserApi } from '~/api/user-api';

export interface UserModel {
	id: string;
	userLoginName: string;
	surname: string;
	givenName: string;
}

@autoinject
export class UserService {
	// holds a max size of cache
	private readonly USER_MODEL_SIZE = 20;
	private userModels: Map<string, UserModel> = new Map();

	public constructor(private userApi: UserApi) {}

	public getUserInfo(userId: string): Promise<UserModel> {
		const cachedUserModel = this.userModels.get(userId);
		if (cachedUserModel) {
			return Promise.resolve(cachedUserModel);
		} else {
			return this.userApi
				.getUserModel(Number(userId))
				.then((userModel: UserModel) => {
					if (userModel) {
						this.cacheUser(userModel);
						return userModel;
					} else {
						throw new Error('Null usermodel returned');
					}
				});
		}
	}

	public async getUserName(userId: string): Promise<string> {
		const userModel = await this.getUserInfo(userId);
		return userModel.userLoginName;
	}

	private cacheUser(userModel: UserModel) {
		if (
			this.userModels.size >= this.USER_MODEL_SIZE &&
			this.userModels.size > 0
		) {
			this.userModels.delete(this.userModels.keys().next().value);
		}
		this.userModels.set(userModel.id, userModel);
	}
}
